import React, { FC, isValidElement, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

import { getRoute } from 'src/routes';
import { RootState } from 'src/store/types';

import { redirectToLogin } from '../utils';

export const ComponentWithSecureRoute: FC<{ children: ReactNode }> = ({ children }) => {
  const location = useLocation();
  const { authenticated } = useSelector((state: RootState) => state.user);

  if (!authenticated || !isValidElement(children)) {
    redirectToLogin();
    return null;
  }

  if (location.pathname === getRoute('validate')) {
    return <Navigate to={getRoute('root')} />;
  }

  return <>{children}</>;
};
